import styled, { css } from 'styled-components';

type ButtonVariants = 'primary' | 'secondary' | 'danger';

type ButtonProps = {
  children: string;
  onClick?: () => void;
  isLoading?: boolean;
  loadingText?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  variant?: ButtonVariants;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({
  children,
  onClick,
  isLoading,
  loadingText = 'Loading...',
  disabled,
  style,
  variant = 'primary',
  ...props
}: ButtonProps) => {
  return (
    <StyledBtn
      {...props}
      disabled={disabled || isLoading}
      onClick={onClick}
      variant={variant}
      style={style}>
      {isLoading ? loadingText : children}
    </StyledBtn>
  );
};

export const PrimaryStyle = css`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: 0.5rem;
  border: none;
  padding: 0.5rem 2rem;
`;

const SecondaryStyle = css`
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
`;

const DangerStyle = css`
  background-color: ${({ theme }) => theme.colors.red};
  color: white;
`;

const StyledBtn = styled.button<{ disabled?: boolean; variant: ButtonVariants }>`
  border-radius: 0.5rem;
  color: white;
  padding: 0.5rem 2rem;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: 0.5s;

  ${({ variant }) => variant === 'primary' && PrimaryStyle}
  ${({ variant }) => variant === 'secondary' && SecondaryStyle}
  ${({ variant }) => variant === 'danger' && DangerStyle};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  @media (max-width: 850px) {
    font-size: 0.8rem;
  }
`;
